import React, { useContext } from 'react';
import { View, StyleSheet, ViewStyle } from 'react-native';
import { EmphasizedSubText, ThemeContext } from '..';

interface BulletPointProps {
  bulletPointStyle?: ViewStyle;
  textStyle?: ViewStyle;
  containerStyle?: ViewStyle;
  text: string;
  emphStyle?: ViewStyle;
}

/*eslint-disable react-native/no-unused-styles*/
const getStyles = (theme: Theme): Record<string, Record<string, string | number>> =>
  StyleSheet.create({
    container: {
      justifyContent: 'flex-start',
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: 10,
    },
    icon: {
      color: theme.colors.primary.normal,
      fontSize: 5,
      marginRight: 10,
    },
  });

export const BulletPoint = ({
  bulletPointStyle,
  textStyle,
  containerStyle,
  text,
  emphStyle,
}: BulletPointProps): React.JSX.Element=> {
  const theme = useContext(ThemeContext);
  const styles = getStyles(theme);
  const { IconComponent } = theme;

  return (
    <View style={[styles.container, containerStyle]}>
      <IconComponent name="circle" style={[styles.icon, bulletPointStyle]} />
      <EmphasizedSubText text={text} style={textStyle} emphStyle={emphStyle} />
    </View>
  );
};
